export interface Novel {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  status: '连载中' | '已完结';
  wordCount: string;
  totalChapters: number;
  latestChapter: string;
  latestChapterId: string;
  updateTime: string;
  rating: number;
  readers: string;
  tags: string[];
}

export interface Chapter {
  id: string;
  novelId: string;
  title: string;
  content: string;
  updateTime: string;
  wordCount: number;
  chapterNumber: number;
}

export interface Category {
  slug: string;
  name: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'xuanhuan', name: '玄幻奇幻', count: 1280 },
  { slug: 'wuxia', name: '武侠仙侠', count: 956 },
  { slug: 'dushi', name: '都市言情', count: 2134 },
  { slug: 'lishi', name: '历史军事', count: 743 },
  { slug: 'kehuan', name: '科幻灵异', count: 621 },
  { slug: 'wangyou', name: '网游竞技', count: 489 },
  { slug: 'xuanyi', name: '悬疑推理', count: 387 },
  { slug: 'qita', name: '其他类型', count: 256 },
];

export const featuredNovel: Novel = {
  id: 'gongce',
  title: '公厕',
  author: '竹巷',
  coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20novel%20book%20cover%20design%20featuring%20a%20dimly%20lit%20night%20scene%20with%20warm%20amber%20streetlight%20reflections%20on%20wet%20pavement%2C%20misty%20atmosphere%2C%20minimalist%20composition%20with%20large%20negative%20space%20for%20title%20text%2C%20moody%20cinematic%20photography%20style%2C%20dark%20warm%20tones%2C%20subtle%20grain%20texture%2C%20contemporary%20Chinese%20literature%20aesthetic&width=600&height=800&seq=gongce-cover-01&orientation=portrait',
  description: '在城市的角落里，一间不起眼的公厕成为了命运交织的节点。各色人物在这里相遇、擦肩，每个人背后都藏着不为人知的故事。竹巷以细腻的笔触描绘都市边缘人的生存图景，用独特的视角解构现代都市中的人性百态。这是一部关于孤独、救赎与希望的现实主义力作，在污浊中寻找洁净，在黑暗中捕捉微光。',
  category: '都市言情',
  status: '连载中',
  wordCount: '168万字',
  totalChapters: 847,
  latestChapter: '第八百四十七章 最后的告别',
  latestChapterId: 'ch-847',
  updateTime: '2026-08-07 03:42',
  rating: 9.6,
  readers: '128.6万',
  tags: ['现实主义', '都市', '人性', '悬疑', '社会'],
};

export const hotNovels: Novel[] = [
  {
    id: 'gongce',
    title: '公厕',
    author: '竹巷',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Chinese%20novel%20cover%20with%20amber%20streetlight%20reflecting%20on%20wet%20ground%20in%20a%20quiet%20alley%20at%20night%2C%20moody%20cinematic%20photography%2C%20minimal%20composition%2C%20warm%20dark%20tones&width=300&height=400&seq=novel-cover-01&orientation=portrait',
    description: '在城市的角落里，一间不起眼的公厕成为了命运交织的节点...',
    category: '都市言情',
    status: '连载中',
    wordCount: '168万字',
    totalChapters: 847,
    latestChapter: '第八百四十七章 最后的告别',
    latestChapterId: 'ch-847',
    updateTime: '2026-08-07 03:42',
    rating: 9.6,
    readers: '128.6万',
    tags: ['现实主义', '都市', '人性'],
  },
  {
    id: 'canghai',
    title: '沧海浮生录',
    author: '烟雨江南',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20classical%20Chinese%20martial%20arts%20novel%20cover%20with%20misty%20mountains%20and%20a%20solitary%20figure%20standing%20on%20cliff%20edge%20at%20sunrise%2C%20traditional%20ink%20painting%20style%20blended%20with%20photography%2C%20ethereal%20atmosphere%2C%20warm%20golden%20light&width=300&height=400&seq=novel-cover-02&orientation=portrait',
    description: '天地为局，众生为棋。一个被遗弃的少年在沧海桑田中寻找身世之谜...',
    category: '武侠仙侠',
    status: '连载中',
    wordCount: '245万字',
    totalChapters: 1203,
    latestChapter: '第一千二百零三章 沧海横流',
    latestChapterId: 'ch-canghai-1203',
    updateTime: '2026-08-06 22:15',
    rating: 9.3,
    readers: '95.2万',
    tags: ['仙侠', '修炼', '热血'],
  },
  {
    id: 'yecheng',
    title: '夜城往事',
    author: '午夜兰花',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20noir%20style%20Chinese%20mystery%20novel%20cover%20showing%20a%20rainy%20city%20street%20at%20night%20with%20neon%20sign%20reflections%2C%20lonely%20silhouette%20under%20umbrella%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%2C%20moody%20atmosphere&width=300&height=400&seq=novel-cover-03&orientation=portrait',
    description: '深夜的城市从不沉睡，每一盏灯背后都藏着一个秘密...',
    category: '悬疑推理',
    status: '已完结',
    wordCount: '89万字',
    totalChapters: 432,
    latestChapter: '第四百三十二章 真相大白（大结局）',
    latestChapterId: 'ch-yecheng-432',
    updateTime: '2026-07-28 18:00',
    rating: 9.1,
    readers: '56.8万',
    tags: ['悬疑', '推理', '都市'],
  },
  {
    id: 'xinghe',
    title: '星河帝国',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Chinese%20web%20novel%20cover%20with%20a%20massive%20spaceship%20fleet%20against%20a%20colorful%20nebula%20backdrop%2C%20futuristic%20military%20aesthetic%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=300&height=400&seq=novel-cover-04&orientation=portrait',
    description: '人类踏入星际时代，一个普通士兵如何在银河纷争中建立自己的帝国...',
    category: '科幻灵异',
    status: '连载中',
    wordCount: '312万字',
    totalChapters: 1560,
    latestChapter: '第一千五百六十章 帝国崛起',
    latestChapterId: 'ch-xinghe-1560',
    updateTime: '2026-08-07 01:30',
    rating: 9.4,
    readers: '189.3万',
    tags: ['科幻', '星际', '热血'],
  },
  {
    id: 'changan',
    title: '长安十二时辰',
    author: '马伯庸',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20novel%20cover%20depicting%20ancient%20Tang%20dynasty%20Changan%20cityscape%20at%20dusk%20with%20lanterns%20and%20pagoda%20rooftops%2C%20warm%20golden%20hour%20light%2C%20classical%20Chinese%20architecture%2C%20rich%20cultural%20atmosphere&width=300&height=400&seq=novel-cover-05&orientation=portrait',
    description: '天宝三载，上元节前夕，长安城陷入了一场惊天危机...',
    category: '历史军事',
    status: '已完结',
    wordCount: '56万字',
    totalChapters: 280,
    latestChapter: '第二百八十章 长安永安（终章）',
    latestChapterId: 'ch-changan-280',
    updateTime: '2026-06-15 12:00',
    rating: 9.8,
    readers: '210.5万',
    tags: ['历史', '悬疑', '唐朝'],
  },
  {
    id: 'tianming',
    title: '天命赊刀人',
    author: '烽火戏诸侯',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20fantasy%20novel%20cover%20featuring%20an%20ancient%20bronze%20knife%20on%20a%20wooden%20table%20with%20candlelight%2C%20traditional%20Chinese%20occult%20elements%2C%20dark%20moody%20atmosphere%20with%20warm%20candle%20glow%2C%20mystical%20aesthetic&width=300&height=400&seq=novel-cover-06&orientation=portrait',
    description: '我有一刀，可断因果，可斩天命，但我只是一个赊刀人...',
    category: '玄幻奇幻',
    status: '连载中',
    wordCount: '198万字',
    totalChapters: 986,
    latestChapter: '第九百八十六章 刀出如龙',
    latestChapterId: 'ch-tianming-986',
    updateTime: '2026-08-07 00:05',
    rating: 9.5,
    readers: '156.7万',
    tags: ['玄幻', '热血', '江湖'],
  },
];

export const chapters: Chapter[] = [
  {
    id: 'ch-847',
    novelId: 'gongce',
    title: '第八百四十七章 最后的告别',
    content: '夜色如墨，街灯昏黄的光晕在潮湿的地面上洇开一片模糊的暖色。\n\n林远站在公厕门口，手里攥着那把已经磨得发亮的铜钥匙。这把钥匙陪伴了他整整三年，见证了无数个深夜里的孤独守望。\n\n"真的要走了？"身后传来老陈的声音，带着一丝沙哑。\n\n林远没有回头，只是点了点头。他的目光越过公厕低矮的屋顶，望向远处高楼大厦的霓虹灯火。这座城市从不缺少光芒，只是那些光芒从来不会照进这里。\n\n老陈叹了口气，从口袋里摸出一包皱巴巴的烟，抽出一根递过去。林远接过来，却没有点燃，只是把它别在了耳朵上。\n\n"这地方，"老陈环顾四周，目光复杂，"送走了多少人，又迎来了多少人。你是待得最久的一个。"\n\n"也是最傻的一个。"林远终于笑了，笑容里带着苦涩。\n\n三年前，他刚从大学毕业，怀揣着对这座城市的憧憬来到这里。谁知道命运会把他带到这间公厕——他在这里遇到了苏念，那个改变他一生的女孩。\n\n那是一个雨夜，苏念浑身湿透地冲进公厕，不是来上厕所，而是来躲避追她的人。林远记得她当时的样子——头发贴在苍白的脸上，眼睛里满是惊恐，像一只受惊的小鹿。\n\n他帮她藏在了工具间里，用清洁车的防水布盖住了她。那些人进来搜查了一圈，骂骂咧咧地走了。从那以后，苏念每隔几天就会来这里，有时候带一杯热咖啡，有时候带一本书，有时候只是坐在门口的台阶上和林远聊天。\n\n她教他看懂了这个城市的另一面——那些隐藏在繁华背后的暗流，那些不为人知的交易和秘密。也是她告诉他，他的父亲并非死于意外，而是被人谋害。\n\n"你真的要去找那个人？"老陈的声音把他拉回现实。\n\n"是时候了。"林远握紧了钥匙，"三年了，我等的就是这一天。"\n\n他转身走进公厕，最后一次检查每一个隔间。第三间的门板上还留着苏念用口红写的那行字——"林远，活着。"\n\n那是她最后一次来这里时留下的。那天之后，她就消失了。\n\n林远伸出手指，轻轻抚摸那两个字。口红的颜色已经褪得很淡了，但在他眼里，那两个字像火焰一样灼热。\n\n"走吧。"他对自己说，然后头也不回地走出了公厕。\n\n门外，一辆黑色的轿车已经等在路边。车窗缓缓降下，露出一张他既熟悉又陌生的脸。\n\n"上车。"那人说。\n\n林远深吸一口气，将铜钥匙放进口袋，拉开了车门。\n\n引擎声响起，轿车消失在夜色中。而公厕的灯光，在身后一盏一盏地熄灭。\n\n——\n\n（未完待续）\n\n更新时间：2026年8月7日 03:42\n下一章预告：第八百四十八章 深渊之下',
    updateTime: '2026-08-07 03:42',
    wordCount: 3247,
    chapterNumber: 847,
  },
  {
    id: 'ch-846',
    novelId: 'gongce',
    title: '第八百四十六章 暗流涌动',
    content: '苏念已经整整一周没有出现了。\n\n林远每天都按时来到公厕，打扫卫生、更换厕纸、检查水管。一切照旧，只是那个熟悉的身影再也没有出现在门口的台阶上。\n\n他开始感到不安。三年来，苏念从未失联超过三天。每次离开前，她都会留下一张纸条，告诉他大概什么时候回来。但这一次，什么都没有。\n\n"你那个女娃朋友呢？"老陈端着保温杯走过来，杯子里泡着浓浓的茉莉花茶。\n\n"不知道。"林远低头擦拭着洗手台，声音很轻。\n\n老陈看了他一眼，欲言又止。他在这附近开报刊亭十几年了，见过太多人来人往。苏念那样的女孩，一看就不是普通人家的孩子——穿着打扮、谈吐气质，都透着一股与众不同的味道。\n\n"年轻人，"老陈最后还是忍不住开口，"有些事，不该碰的就别碰。安安稳稳过日子，比什么都强。"\n\n林远没有回答。\n\n他知道老陈是好意，但他更知道，有些事情一旦开始，就没有回头路。\n\n下午三点，公厕里来了一位不速之客。\n\n那人穿着一身剪裁考究的深色西装，皮鞋擦得锃亮，与这间破旧的公厕格格不入。他站在洗手台前，透过镜子打量着林远。\n\n"你就是林远？"\n\n林远抬起头，对上一双锐利如鹰隼的眼睛。\n\n"你是谁？"\n\n"我是谁不重要。"那人从西装内袋里掏出一个牛皮纸信封，放在洗手台上，"重要的是，这里面的东西。"\n\n林远没有去拿。\n\n"苏念让我转告你，"那人整理着袖口，漫不经心地说，"她暂时不能来见你了。有些事情需要处理。让你不用担心。"\n\n"她在哪？"\n\n"在一个安全的地方。"那人转身准备离开，走到门口时停了一下，"哦对了，她还说——别忘了看第三间的门板。"\n\n脚步声远去。\n\n林远冲向第三间隔间，门板上，一行鲜红的口红字映入眼帘——\n\n"林远，活着。"\n\n他的心脏猛地收紧。这是苏念的笔迹，他认得。但这句话，更像是一个警告。\n\n活着。为什么要特意写这两个字？除非她觉得——自己可能活不了。\n\n林远攥紧了拳头，指甲深深嵌进掌心。他打开那个牛皮纸信封，里面是一张泛黄的照片和一把钥匙。\n\n照片上是一个中年男人，站在一栋大楼前，笑容温和。那是他的父亲。\n\n而钥匙上刻着一行小字：东方大厦 B3-47号储物柜。\n\n林远的手开始颤抖。三年前父亲去世，警方说是交通事故意外身亡。但苏念曾经暗示过，那根本不是意外。\n\n现在，父亲的照片和一把神秘的钥匙同时出现——这意味着什么？\n\n他抬头看向窗外，夕阳正在西沉，将天空染成一片血色。\n\n这座城市的地下，有太多不为人知的秘密正在涌动。\n\n而他，已经站在了漩涡的边缘。\n\n——\n\n（未完待续）\n\n更新时间：2026年8月6日 21:18',
    updateTime: '2026-08-06 21:18',
    wordCount: 3102,
    chapterNumber: 846,
  },
  {
    id: 'ch-845',
    novelId: 'gongce',
    title: '第八百四十五章 雨夜的访客',
    content: '暴雨如注，整座城市仿佛被浸泡在一个巨大的水缸里。\n\n林远值夜班。这种天气，公厕里几乎没有人来。他坐在收银台后面的小板凳上，借着昏黄的灯光翻看一本旧书。\n\n门突然被推开了。\n\n风卷着雨水灌进来，一个浑身湿透的年轻人跌跌撞撞地冲了进来。他看起来很年轻，大约二十出头，穿着一件洗得发白的牛仔夹克。\n\n"有纸巾吗？"年轻人问道，声音里带着喘。\n\n林远从抽屉里拿出一包纸巾递过去。年轻人接过来，胡乱擦了一把脸上的水，然后靠在墙边，大口喘着气。\n\n"有人在追你？"林远问。\n\n年轻人警觉地看了他一眼，然后摇了摇头："没有。就是雨太大了。"\n\n林远没有追问。在这间公厕里，他见过太多不想说实话的人。有些人在躲债，有些人在躲仇家，有些人在躲自己。\n\n年轻人站了一会儿，从口袋里掏出一个防水袋，里面装着一部手机。他看了看屏幕，脸色变了变。\n\n"大哥，"他突然开口，"这里还有别的出口吗？"\n\n林远指了指后面："有个后门，通向小巷子。"\n\n"谢谢。"年轻人快步往后门走去，走到一半又折回来，从防水袋里抽出一张纸片塞到林远手里，"如果有个叫苏念的女孩来找你，帮我把这个给她。"\n\n说完，他拉开后门，消失在雨幕中。\n\n林远低头看那张纸片，上面只写了一行字："B3层的灯又亮了。"\n\n他的瞳孔骤然收缩。\n\nB3层——那是东方大厦地下停车场的最底层。但他知道那不仅仅是一个停车场。苏念曾经隐约提起过，那里藏着某种重要的东西。\n\n雨声越来越大，公厕的灯光忽明忽暗。\n\n林远把纸片小心折好，放进贴身的口袋里。他有一种强烈的预感——今晚，有什么事情即将发生。\n\n果然，不到十分钟，公厕的门再次被推开。\n\n这次进来的，是一个撑着黑伞的男人。他的伞压得很低，看不清脸。雨水顺着伞骨滴落，在地面上汇成一小滩水。\n\n"刚才有个年轻人来过这里？"男人开口，声音平静得没有一丝波澜。\n\n林远的心跳漏了一拍。\n\n"没有。"他听见自己说。\n\n男人沉默了几秒，然后缓缓抬起伞。\n\n林远终于看清了那张脸——那是一张精致得近乎不真实的面孔，五官如同雕塑般完美，但眼睛里没有任何温度。\n\n"你确定？"男人微微一笑，笑容里没有一丝暖意。\n\n"这里每天晚上来来往往的人很多，"林远保持着镇定，"我不可能记住每一个人。"\n\n男人的目光在公厕里扫了一圈，最后落在了后门上。\n\n"这样啊。"他收回目光，重新将伞压低，"那就打扰了。"\n\n他转身离开，脚步声在雨声中渐渐远去。\n\n林远这才发现自己手心全是冷汗。他见过很多人，但这个男人的压迫感是他从未遇到过的。\n\n那个人身上，有一种死亡的气息。\n\n林远站起身，走到后门边。门外的巷子里空无一人，雨水冲刷着一切痕迹。\n\n但他知道，暴风雨才刚刚开始。\n\n——\n\n（未完待续）\n\n更新时间：2026年8月5日 23:55',
    updateTime: '2026-08-05 23:55',
    wordCount: 2956,
    chapterNumber: 845,
  },
];

export const newUpdates: Novel[] = [
  featuredNovel,
  hotNovels[1],
  hotNovels[3],
  hotNovels[5],
];

export const recommendedNovels: Novel[] = [
  hotNovels[2],
  hotNovels[4],
  {
    id: 'yijian',
    title: '一剑封神',
    author: '我吃西红柿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20fantasy%20novel%20cover%20with%20a%20swordsman%20silhouette%20against%20a%20full%20moon%2C%20ancient%20Chinese%20landscape%20with%20pine%20trees%2C%20dramatic%20moonlight%2C%20warm%20silver%20and%20dark%20tones%2C%20epic%20composition&width=300&height=400&seq=novel-cover-07&orientation=portrait',
    description: '一人一剑，杀穿天界，只为寻回失落的故人...',
    category: '武侠仙侠',
    status: '连载中',
    wordCount: '156万字',
    totalChapters: 780,
    latestChapter: '第七百八十章 剑指苍穹',
    latestChapterId: 'ch-yijian-780',
    updateTime: '2026-08-06 20:30',
    rating: 9.2,
    readers: '78.3万',
    tags: ['仙侠', '热血', '修炼'],
  },
  {
    id: 'dujia',
    title: '独家记忆',
    author: '木浮生',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20modern%20romance%20novel%20cover%20with%20soft%20cherry%20blossom%20petals%20falling%20in%20a%20quiet%20campus%20path%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20tender%20dreamy%20atmosphere%2C%20pastel%20warm%20tones&width=300&height=400&seq=novel-cover-08&orientation=portrait',
    description: '如果记忆可以删除，你会选择忘记谁？一段关于爱与遗忘的都市爱情故事...',
    category: '都市言情',
    status: '已完结',
    wordCount: '42万字',
    totalChapters: 210,
    latestChapter: '第二百一十章 此生不负（大结局）',
    latestChapterId: 'ch-dujia-210',
    updateTime: '2026-07-20 16:45',
    rating: 9.0,
    readers: '42.1万',
    tags: ['言情', '都市', '治愈'],
  },
];